import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
// Styles
import './formElements.css';
import { stringToSlug } from '../../../helpers/utils';
import { Choose, Otherwise, When } from '../../renderConditional';

/* eslint-disable */
class Button extends Component {
  render() {
    const METRIC_ID =
      stringToSlug(this.props.text) || stringToSlug(this.props.title) || '';
    return (
      <Choose>
        <When condition={this.props.type === 'link'}>
          <a
            href={this.props.href}
            className={classNames('btn', this.props.className)}
            data-metrics={METRIC_ID}
            target={this.props.target}
            title={this.props.title}
            disabled={this.props.disabled}
            data-qa={this.props.qaId}
            style={this.props.style}
          >
            {this.props.icon}
            {this.props.text}
            {this.props.iconRight}
          </a>
        </When>
        <When
          condition={this.props.type === 'router-link'}
          target={this.props.target}
        >
          <Link
            to={{
              pathname: this.props.href,
              search: this.props.params,
            }}
            className={classNames('btn', this.props.className)}
            data-metrics={METRIC_ID}
            title={this.props.title}
            disabled={this.props.disabled}
            data-qa={this.props.qaId}
            style={this.props.style}
          >
            {this.props.icon}
            {this.props.text}
            {this.props.iconRight}
          </Link>
        </When>
        <Otherwise>
          <button
            type={this.props.type}
            className={classNames('btn', this.props.className)}
            data-metrics={METRIC_ID}
            title={this.props.title}
            disabled={this.props.disabled}
            data-qa={this.props.qaId}
            onClick={(e) => this.props.onClickHandler(e)}
            style={this.props.style}
          >
            {this.props.icon}
            <span>{this.props.text}</span>
            {this.props.iconRight}
          </button>
        </Otherwise>
      </Choose>
    );
  }
}

Button.defaultProps = {
  onClickHandler: () => {},
  disabled: false,
  qaId: '',
};

Button.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  target: PropTypes.string,
  href: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  onClickHandler: PropTypes.func,
  icon: PropTypes.element,
  iconRight: PropTypes.element,
  disabled: PropTypes.bool,
  qaId: PropTypes.string,
  params: PropTypes.string,
};

export default compose(
  connect(
    (state) => ({
      params: state.MetricsReducer.params,
    }),
    {}
  )
)(Button);
